// extracted by mini-css-extract-plugin
export default {"section":"LeadingBeverageStudy_section__edZJm","sectionContent":"LeadingBeverageStudy_sectionContent__kqqWP","reverseMobile":"LeadingBeverageStudy_reverseMobile__oORPs"};